module.exports = __webpack_public_path__ + "static/img/7_yali.c9f7dbf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/7_yali.png
// module id = cHST
// module chunks = 0